module.exports = __webpack_public_path__ + "static/GNT1-dbf67268c021d6a5ea7171ed31928e07.jpg";